<template lang="pug">
    .msg
        //- .left.box
        //-     .nomsg
        //-         el-empty(:image-size="100")
        .right.box
            .container
                dl
                    dt 恭喜您获得了用户邀请权限
                    dd
                        p 目前『卫星发现』尚处于测试阶段，未开放公开注册。您作为初期用户，获得了新用户邀请的权限。
                        p 分享邀请海报给好友，好友通过微信扫码注册为『卫星发现』用户，即视为邀请成功。
                        p 每成功邀请一位好友，您和您的好友将各获得一个单位的AOI代金券。
                    dd
                        .share-box {{shareText}}
                        el-button.share-btn(@click="copy") 复制到粘贴板
</template>

<script>
import storeMixin from '../store/mixin';

export default {
    name: 'Msg',
    mixins: [storeMixin],

    data() {
        return {};
    },
    created() {
        console.log('created');
    },
    computed: {
        href() {
            const { protocol, host, pathname } = window.location;
            return `${protocol}//${host}${pathname}?ic=${this.USER.INVITATION_CODE}`;
        },
        shareText() {
            return `${
                (this.USER && this.USER.NICKNAME) || '您的好友'
            }邀请您体验卫星发现!接受邀请，请使用PC浏览器打开网址 ${this.href}`;
        },
    },
    methods: {
        async copy() {
            try {
                await window.navigator.clipboard.writeText(this.shareText);
                this.$message({
                    message: '复制成功',
                    type: 'success',
                });
            } catch (e) {
                console.log(e);
                this.$message({
                    message: '复制出错，请手动复制',
                    type: 'warning',
                });
            }
        },
    },
};
</script>

<style lang="stylus" scoped>
.msg
    display flex
    width 100%
.left
    margin 0 20px 0 0
    width 300px
    flex-shrink 0
    .nomsg
        width 100%
        height 100%
        display flex
        flex-direction column
        align-items center
        justify-content center
        & > *
            margin 10px 0
.right
    text-align center
    flex-grow 1
    overflow auto
    .container
        margin 50px

    dt
        font-size 32px
        margin 0 0 20px 0
    dd
        text-align left
        &.tc
            text-align center
        &:first-of-type
            margin 0 0 20px 0
    img
        width 300px
.share-box
    padding 50px
    text-align center
    border 1px solid rgba(255,255,255,.3)
    border-radius 15px
    margin-bottom 20px
</style>
